/**
 * FilterGroup — agrupacion (label uppercase + chips de filtro).
 *
 * Sustituye codigo identico que estaba duplicado en:
 *   - apps/dashboard/src/features/tablero/tabs/TabInventario.tsx (FilterGroup local)
 *   - apps/dashboard/src/features/filters/FilterBar.tsx          (FilterGroup local)
 *
 * Los chips son el `.chip-btn` canonico (definido en dashboard.css y compartido
 * via @aosenuma/ui/styles/globals.css). Variante de "activo":
 *   - `soft`   (default) -> teal-soft suave dentro del panel
 *   - `strong`           -> lime solido (firma del visor; usar solo sobre mapa)
 */
import type { ReactNode } from 'react';

export type FilterGroupActive = 'soft' | 'strong';

export interface FilterOption<V extends string = string> {
  value: V;
  label: ReactNode;
}

interface FilterGroupProps<V extends string = string> {
  label: string;
  options: FilterOption<V>[];
  active: V;
  onChange: (v: V) => void;
  variant?: FilterGroupActive;
}

export function FilterGroup<V extends string = string>({
  label,
  options,
  active,
  onChange,
  variant = 'soft',
}: FilterGroupProps<V>) {
  return (
    <div className="inv-filter-group">
      <span className="inv-filter-label">{label}</span>
      <div className="inv-chip-row">
        {options.map((o) => (
          <button
            key={o.value}
            type="button"
            className={`chip-btn ${active === o.value ? 'is-active' : ''} ${variant === 'strong' ? '' : 'chip-btn--soft'}`}
            onClick={() => onChange(o.value)}
            data-variant={variant}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}
